import * as React from 'react';
import CSS from 'csstype';
import { withRouter, RouteComponentProps } from 'react-router';
import { useDispatch } from 'react-redux';
import { trackClick } from '../utils/analytics';
import type { EventProperties } from '../utils/analytics';
import handleEnterKey from '../utils/handle-enter-key';
import css from './cell.module.css';
import type { Dispatch } from '../types/app.types';

type Props = RouteComponentProps & {
  children?: React.ReactNode;
  to?: string;
  onClick?: (...args: Array<any>) => any;
  noIcon?: boolean;
  icon?: string;
  eventName?: string;
  eventData?: EventProperties;
  hideBottomBorder?: boolean;
  hidePadding?: boolean;
  dataQA?: string;
  style?: CSS.Properties<string | number>;
  cellContentStyle?: CSS.Properties<string | number>;
};

const clickHandler = (props, dispatch) => {
  const { history, onClick, to, eventName, eventData } = props;
  if (eventName) dispatch(trackClick(eventName, 'cell', eventData));
  if (onClick) return onClick();
  if (to) history.push(to);
};

function Cell(props: Props) {
  const {
    children,
    noIcon,
    icon,
    to,
    onClick,
    hideBottomBorder = false,
    hidePadding = false,
    style,
    cellContentStyle,
  } = props;
  const dispatch = useDispatch<Dispatch>();
  const interactive = Boolean(to || onClick);
  const interactiveProps = interactive
    ? {
        role: to ? 'link' : 'button',
        tabIndex: 0,
        onKeyDown: handleEnterKey(() => clickHandler(props, dispatch)),
        onClick: () => clickHandler(props, dispatch),
      }
    : {};
  const contentClassName = hideBottomBorder ? `${css.content}` : `${css.content} ${css.bordered}`;
  const contentClassNamePadded = hidePadding ? `${contentClassName}` : `${contentClassName} ${css.padded}`;
  return (
    <div className={css.cell} {...interactiveProps} data-qa={props.dataQA} style={{ ...style }}>
      <div className={contentClassNamePadded} style={{ ...cellContentStyle }}>
        {children}
        {!noIcon && <img className={css.contentIcon} src={icon || require('./arrow.svg')} alt="arrow" />}
      </div>
    </div>
  );
}

export default withRouter(Cell);
